import React, { useState, useCallback } from 'react';

const WarehouseInput: React.FC<{
    warehouses: string[];
    onAddWarehouse: (warehouse: string) => void;
    onRemoveWarehouse: (warehouseToRemove: string) => void;
    disabled?: boolean;
}> = ({ warehouses, onAddWarehouse, onRemoveWarehouse, disabled = false }) => {
    const [inputValue, setInputValue] = useState('');

    const addWarehouse = useCallback(() => {
        const warehouse = inputValue.trim();
        if (warehouse && !warehouses.includes(warehouse)) {
            onAddWarehouse(warehouse);
            setInputValue('');
        }
    }, [inputValue, warehouses, onAddWarehouse]);

    const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addWarehouse();
        } else if (e.key === 'Backspace' && inputValue === '' && warehouses.length) {
            // Remove last tag when backspace is pressed on empty input
            onRemoveWarehouse(warehouses[warehouses.length - 1]);
        }
    }, [inputValue, warehouses, addWarehouse, onRemoveWarehouse]);

    return (
        <>
            <div className="tags-input-container">
                <div className="warehouse-tags">
                    {warehouses.map((warehouse, index) => (
                        <span key={index} className="warehouse-tag">
                            {warehouse}
                            <button
                                type="button"
                                className="tag-remove"
                                onClick={() => onRemoveWarehouse(warehouse)}
                                disabled={disabled}
                                title="Удалить склад"
                            >
                                ×
                            </button>
                        </span>
                    ))}
                </div>
                <input
                    type="text"
                    className="form-input-custom tags-input"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Добавить склад..."
                    disabled={disabled}
                />
            </div>
            <div className="form-help-text">
                Введите название склада и нажмите Enter или запятую для добавления
            </div>
            {warehouses.length > 0 && (
                <div className="warehouse-count">
                    Выбрано складов: {warehouses.length}
                </div>
            )}
        </>
    );
};

export default WarehouseInput;
